class ProductSliderScroller extends HTMLElement {
  connectedCallback() {
    this.productCarousel = this.querySelector('[data-product-carousel]');
    this.imagesAlts = this.productCarousel.cells.map(cell => cell.querySelector('img')?.alt ?? '')
  }

  selectImageByAlt(alt) {
    // Find the index of the image with alt that contains the alt
    const index = this.imagesAlts.indexOf(this.imagesAlts.find(imageAlt => imageAlt.includes(alt)))
    if (index === undefined || index === -1) return
    this.productCarousel.select(index)
  }
}

if (!window.customElements.get("product-slider-scroller")) {
  customElements.define('product-slider-scroller', ProductSliderScroller);
}

class ScrollToAltBtn extends HTMLElement {
  connectedCallback() {
    this.boundClickHandler = this.clickHandler.bind(this);
    this.addEventListener('click', this.boundClickHandler);
  }

  clickHandler() {
    const closestProductWrapper = this.closest('product-rerender');
    if (!closestProductWrapper) return;
    const gallery = closestProductWrapper.querySelector('product-slider-scroller');
    if (!gallery) return;
    gallery.selectImageByAlt(this.dataset.galleryScrollToAlt);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.boundClickHandler);
  }
}

if (!window.customElements.get("scroll-to-alt-btn")) {
  customElements.define('scroll-to-alt-btn', ScrollToAltBtn);
}
